import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const redeemApi = createAsyncThunk(
  "redeem_fintso",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.customerName = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/fintso_transactions/redeem", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      // console.log("customerName", response.data);
      return response.data;
    }
  }
);

const redeemSlice = createSlice({
  name: "redeem_fintso",
  initialState: {
    redeem: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(redeemApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(redeemApi.fulfilled, (state, action) => {
        state.redeem = action.payload;
        state.loading = false;
      })
      .addCase(redeemApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default redeemSlice.reducer;
